import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-warning.tsx
/**
* icon.16.warning
*
* Attention, warning, exclamation mark
*
* Keywords: alert, caution, triangle, exclamation, danger, notification, safety
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi4yODUgMi45MTVjLjc3Ny0xLjI5NSAyLjY1My0xLjI5NCAzLjQzIDBsNC4yMzQgNy4wNTZjLjggMS4zMzMtLjE2MSAzLjAyOS0xLjcxNiAzLjAyOUgzLjc2NmMtMS41NTQgMC0yLjUxNS0xLjY5Ni0xLjcxNi0zLjAzem0yLjU3Mi41MTRhMSAxIDAgMCAwLTEuNzE1IDBsLTQuMjM0IDcuMDU2YTEgMSAwIDAgMCAuNzE2IDEuNTA1bC4xNDIuMDFoOC40NjdhMSAxIDAgMCAwIC44NTctMS41MTV6TTggOS40OTlBLjc1Ljc1IDAgMSAxIDggMTFhLjc1Ljc1IDAgMCAxIDAtMS41bS4wNzktNC40OTVhLjczLjczIDAgMCAxIC42NDguNzg3bC0uMjMgMi43NWEuNS41IDAgMCAxLS45OTYgMEw3LjI3MiA1Ljc5QS43My43MyAwIDAgMSA4IDV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11977
*/
const Icon16Warning = memo(function Icon16Warning(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6.285 2.915c.777-1.295 2.653-1.294 3.43 0l4.234 7.056c.8 1.333-.161 3.029-1.716 3.029H3.766c-1.554 0-2.515-1.696-1.716-3.03zm2.572.514a1 1 0 0 0-1.715 0l-4.234 7.056a1 1 0 0 0 .716 1.505l.142.01h8.467a1 1 0 0 0 .857-1.515zM8 9.499A.75.75 0 1 1 8 11a.75.75 0 0 1 0-1.5m.079-4.495a.73.73 0 0 1 .648.787l-.23 2.75a.5.5 0 0 1-.996 0L7.272 5.79A.73.73 0 0 1 8 5z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Warning };

//# sourceMappingURL=icon-16-warning.js.map